import { Box, useTheme } from '@mui/material';
import { Dial, Arc, type BaseDialOptions } from 'components/Dial';
import { ControlComponentProps } from 'pages/AIMusicGenerator/components/FormulaItem';
import { KnobValue } from './components';

const MIN_VALUE = 0;
const MAX_VALUE = 100;
const ANGLE_OFFSET = 230;
const ANGLE_RANGE = 260;
const MOUSE_WHEEL_STEP = 0.1;
const MOUSE_MOVE_STEP = 0.5;

const DIAL_OPTIONS: BaseDialOptions = {
  min: MIN_VALUE,
  max: MAX_VALUE,
  angleOffset: ANGLE_OFFSET,
  angleRange: ANGLE_RANGE,
};

type KnobProps = ControlComponentProps<number>;

const Knob = ({ value, onChange }: KnobProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: theme.spacing(12.5),
          height: theme.spacing(12.5),
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Arc value={value} options={DIAL_OPTIONS} />
        <Box
          sx={{
            position: 'absolute',
            width: '70%',
            height: '70%',
          }}
        >
          <Dial
            options={{
              ...DIAL_OPTIONS,
              mouseWheelStep: MOUSE_WHEEL_STEP,
              mouseMoveStep: MOUSE_MOVE_STEP,
            }}
            value={value}
            onChange={onChange}
          />
        </Box>
      </Box>
      <KnobValue value={value} />
    </Box>
  );
};

export default Knob;
